import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import EditUser from '../../components/modals/edituser'
import Receive from '../../components/reusable/receive'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import NewScheme from '../../components/drawers/newScheme'

const Schemes = () => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')

    const [newSchemeModal, toggleNewSchemeModal] = useToggle()
    const [userModal, toggleUserModal] = useToggle()

    const select = usr => {
        setSelected(usr)
        toggleUserModal()
    }
    
    const [
        { loading, error, fetch }, 
        { list: schemes }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('schemes', { string }, { notify: true, manual: false })

    const search = str => {
        setString(str)
        navigate(1)
        fetch()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Scheme has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        fetch()
    }

    const [, execute] = usePet('toggleSchemeActive', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = scheme => {
        setSelected(scheme)
        execute()        
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newSchemeModal &&
                <NewScheme
                    onPerform={ fetch }
                    toggle={ toggleNewSchemeModal }
                    visible={ newSchemeModal } />
            }
            {
                userModal &&
                <EditUser
                    onPerform={ fetch }
                    user={ selected }
                    toggle={ toggleUserModal }
                    visible={ userModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={ toggleNewSchemeModal }>Add New Scheme</Menu.Item>
                                <Menu.Item onClick={ toggleNewSchemeModal }>Download Sale Item List</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Actions</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100">
                    <h2 className="font-semibold text-gray-800">Medical Schemes</h2>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                schemes.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Type</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Operated By / Company</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                schemes.map((scheme, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ scheme.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ scheme.schemeType }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ scheme?.operatedBy?.name ?? scheme?.company?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(scheme.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(scheme) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(scheme) }>{ scheme.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(scheme) }>Upload Sale Item List</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(scheme) }>View Item Pricing</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new scheme</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Schemes